import { render } from "./VacanciesView.vue?vue&type=template&id=6a61d668"
import script from "./VacanciesView.vue?vue&type=script&lang=js"
export * from "./VacanciesView.vue?vue&type=script&lang=js"

import exportComponent from "/Users/alekseisemiguk/Documents/sadko/35FIT-full/35FIT/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__